import RecommendationList from './views/RecommendationList.vue';
import PriceOptimizer from './PriceOptimizer.vue';
import RecommendationDetail from './views/RecommendationDetail.vue';

export const priceOptimizerRoutes = [
  {
    path: 'price-optimizer',
    component: PriceOptimizer,
    children: [
      { path: '', component: RecommendationList, name: 'productRecommendation' },
      {
        path: 'detail', component: RecommendationDetail, name: 'priceDetailByDemand', props: true
      }
    ]
  }
];
